import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  TournamentTeam,
  SignInTeamRequest,
  Team,
} from '@app/_models/tournament.model';
import { PlayersService } from '@app/services/players.service';
import { Player } from '@app/_models/player';
import { startWith, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TournamentsService } from '@app/services/tournaments/tournaments.service';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'tournament-detail-create-team',
  templateUrl: './tournament-detail-create-team.component.html',
})
export class TournamentDetailCreateTeamComponent implements OnInit {
  constructor(
    private _builder: FormBuilder,
    private _playerService: PlayersService,
    private _tournamentService: TournamentsService,
    private _snackBar: MatSnackBar
  ) {}
  @Output() closeEvent = new EventEmitter<boolean>();
  @Output() addTeamEvent = new EventEmitter<Team>();
  players: Player[] = [];
  filteredPlayers: Observable<Player[]>;
  newTeamForm = this._builder.group({
    name: ['', [Validators.required]],
    owner: ['', [Validators.required]],
  });
  ngOnInit() {
    this._playerService.findPlayers('', '', 1, 1000, 1).subscribe(list => {
      this.players = list.payload;
      this.filteredPlayers = this.newTeamForm.get('owner').valueChanges.pipe(
        startWith(''),
        map(val => this.filter(val as string))
      );
    });
  }

  closeDialog() {
    this.closeEvent.emit(false);
  }

  saveTeam() {
    const form = this.newTeamForm;
    const team: Team = {
      name: form.get('name').value as string,
      captain: (form.get('owner').value as Player).id,
    };
    this._tournamentService.createTeam(team).subscribe(newTeam => {
      this.addTeamEvent.emit(newTeam);
    });
  }

  filter(val: string) {
    return this.players.filter(s => new RegExp(val, 'gi').test(s.username));
  }

  displayUsername(el: Player) {
    return el.username;
  }
}
